<template lang="pug">
  .history
    swiper.history__slider(
      :options="swiperOption"
      ref="swiper"
      @slideNextTransitionStart="slideNext"
      @slidePrevTransitionStart="slidePrev"
    )
      swiper-slide.history__slide(
        v-for="(item, index) in history"
        :class="`history__slide--${item.type}`"
      )
        .history__picture.history__picture--desktop
          .history__picture_inner
            img(:src="item.image")
        .history__slide_content
          .history__slide_year(v-if="item.year")
            span(v-for="letter in item.year") {{ letter }}
          .history__picture.history__picture--mobile
            .history__picture_inner
              img(:src="item.image")
          .history__slide_content-part
            .history__slide_title
              span(v-for="titlePart in item.title") {{ titlePart }}
            .history__slide_description
              span(v-for="descriptionPart in item.description") {{ descriptionPart }}
            .history__slide_controls
              button(@click="slidePrev(index - 1)" v-if="index > 0").history__slide_control.cursor__link prev
              button(@click="slideNext(index + 1)" v-if="index < history.length - 1").history__slide_control.cursor__link next

</template>

<script>
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper);
export default {
  name: "PageHistory",
  data: () => ({
    swiperCounter: 1,
    swiperOption: {
      direction: "vertical",
      spaceBetween: 0,
      slidesPerView: "auto",
      mousewheel: false,
      slidesPerGroup: 1,
      noSwiping: true,
      noSwipingClass: "swiper-container",
      speed: 1000,
      navigation: {
        prevEl: ".mobile__prev",
        nextEl: ".mobile__next"
      },
      breakpoints: {
        900: {
          slidesPerView: 1,
          direction: "horizontal",
        }
      }
    },
    history: [
      {
        image: require("./items/slide-1.webp"),
        title: ["Race", "to the Sky"],
        type: "no-dated",
        description: [
          "New York is famous for its skyscrapers, and they embody",
          "the competitive spirit and the American dream most vividly.",
          "Multi-storey construction boom took place during",
          "the turbulent era of the '20s, when there was a real",
          "race to construct the tallest skyscraper. Thus, American ",
          "industrial tycoons sought to demonstrate their power ",
          "to the world and make money on the rapidly growing price ",
          "of Manhattan land."
        ]
      },
      {
        image: require("./items/slide-2.webp"),
        year: [1, 9, 2, 7],
        title: ["Monument to Ambition"],
        type: "dated",
        description: [
          "Architect William Van Alen received a commission for",
          "an office building from former U.S. Senator, developer",
          "William H. Reynolds. Van Alen's initial project was",
          "very ambitious. It was planned that the building",
          "would be 808 ft tall with a crowning glass dome",
          "meant to give the effect of a 'big jeweled sphere'."
        ]
      },
      {
        image: require("./items/slide-3.webp"),
        year: [1, 9, 2, 8],
        title: ["Contribution to", "Business Progress"],
        type: "dated",
        description: [
          "The lease on the plot and the project were bought",
          "for $2 million by automobile magnate Walter",
          "P. Chrysler, TIME's Man of the Year of 1928. Three",
          "years before, Chrysler had founded an auto company",
          "in Detroit and achieved incredible success."
        ]
      },
      {
        image: require("./items/slide-4.webp"),
        year: [1, 9, 2, 9],
        title: ["The World's", "Tallest Building"],
        type: "dated",
        description: [
          "The work was done very quickly: the Chrysler Building was",
          "increasing in height by four floors per week. The building",
          "was actually built in a race with another skyscraper,",
          "the Bank of Manhattan Trust Building, located in Lower",
          "Manhattan at 40 Wall Street (927 ft).",
          "Both buildings claimed to be the tallest in the world,",
          "displacing the Woolworth Building (height 792 ft),",
          "which had occupied this place since 1913."
        ]
      },
      {
        image: require("./items/slide-5.webp"),
        title: ["Triumph"],
        year: [1, 9, 3, 0],
        type: "dated",
        description: [
          "Due to the spire the Chrysler Building surpassed",
          "the Manhattan Trust Building by 121 ft and secured",
          "its title as the tallest building in the world.",
          "It became the first man-made structure in history",
          "with a height of over 1,000 feet, surpassing",
          "the Eiffel Tower by 21 feet.",
        ]
      },
      {
        image: require("./items/slide-6.webp"),
        title: ["Big Launch"],
        type: "no-dated",
        description: [
          "The Chrysler Building officially opened on May 27, 1930.",
          "65 percent of all available space had already been leased.",
          "The Chrysler Building received mixed reactions from",
          "critics, but the general public liked it for",
          "its unusual lighting, upward orientation",
          "which symbolized city's persistent optimism,",
          "progress, and hope for a better future.",
        ]
      }
    ]
  }),
  methods: {
    showPage() {
      this.$el.classList.add("active");
      setTimeout(() => {
        this.$refs.swiper.swiper.slides[0].classList.add("is-active")
      }, 1200)
    },
    slideNext(index){
      this.$refs.swiper.swiper.slides[index - 1].classList.remove("is-active")
      this.slide(index);
      setTimeout(() => {
        this.$refs.swiper.swiper.slides[index].classList.add("is-active")
      }, 1400)
    },
    slidePrev(index){
      this.$refs.swiper.swiper.slides[index + 1].classList.remove("is-active")
      this.slide(index);
      setTimeout(() => {
        this.$refs.swiper.swiper.slides[index].classList.add("is-active")
      }, 1400)
    },
    slide(index) {
      setTimeout(() => {
        this.$refs.swiper.swiper.slideTo(index);
      }, 800)
    },
    clearCursor() {
      document.querySelector(".circle-cursor--outer").remove();
      document.querySelector(".circle-cursor--inner").remove();
    }
  },
  mounted() {
    this.showPage();
  },
  beforeDestroy() {
    this.clearCursor();
  }
};
</script>

<style lang="sass">
@import "src/sass/general/medias"
@import "src/sass/general/variables"
@import "src/sass/general/text"

.history
  height: 100%
  width: 100%
  position: absolute
  top: 0
  left: 0
  outline: 1px solid red
  overflow: hidden
  @media (max-width: $b-tablet)
    padding: 0 $view-indent

.history__slider
  height: 100%
  width: 100%
  .swiper-wrapper
    flex-direction: row!important

.history__slide
  padding: 15vh 10vw
  display: flex
  grid-gap: 6vw
  position: relative
  @media (max-width: $m-desktop)
    padding: 20vh 10vw
  @media (max-width: $s-desktop)
    padding: 30vh 10vw
  @media (max-width: $b-tablet)
    padding: 10vh 0
  &--no-dated
    .history__slide_title
      +yo('font-size', (1920px: 72px, 375px: 32px))
    .history__slide_content
      padding-top: 30px
      @media (max-width: $b-tablet)
        padding-top: 0

  &.is-active
    .history__picture_inner, .history__picture_inner img
      transform: scale(1)
      opacity: 1
    .history__slide_year span, .history__slide_title span, .history__slide_description span, .history__slide_control
      opacity: 1
      transform: translateY(0)
    .history__slide_description
      span
        &:nth-child(1)
          transition-delay: .35s
        &:nth-child(2)
          transition-delay: .4s
        &:nth-child(3)
          transition-delay: .45s
        &:nth-child(4)
          transition-delay: .5s
        &:nth-child(5)
          transition-delay: .55s
        &:nth-child(6)
          transition-delay: .6s
        &:nth-child(7)
          transition-delay: .65s
        &:nth-child(8)
          transition-delay: .7s
        &:nth-child(9)
          transition-delay: .75s
        &:nth-child(10)
          transition-delay: .8s
        &:nth-child(11)
          transition-delay: .85s
    .history__slide_control
      &:nth-child(1)
        transition-delay: .7s
      &:nth-child(2)
        transition-delay: .8s
    .history__picture:before
      opacity: 1
      transform: scale(1)
      transition-delay: .3s

.history__picture
  width: 60%
  position: relative
  @media (max-width: $s-desktop)
    width: 50%
  @media (max-width: $b-tablet)
    width: 100%
    padding-top: 50px
  &:before
    content: ""
    position: absolute
    width: 60em
    top: 0
    bottom: 0
    left: 0
    right: 0
    margin: auto
    height: 60em
    border-radius: 100%
    transition-timing-function: ease
    transition-duration: 1.2s
    transform: scale(.5)
    opacity: 0
    border: 1px solid rgba(210, 173, 117, .3)
    transition-delay: 0s
    @media (max-width: $l-desktop)
      width: 45em
      height: 45em
    @media (max-width: $m-desktop)
      width: 37em
      height: 37em
    @media (max-width: $s-desktop)
      width: 27em
      height: 27em
    @media (max-width: $b-tablet)
      width: 20em
      height: 20em
  &--desktop
    @media (max-width: $b-tablet)
      display: none
  &--mobile
    @media (min-width: $b-tablet + 1)
      display: none

.history__picture_inner
  overflow: hidden
  width: 100%
  height: 100%
  transition-duration: 1.5s
  position: relative
  transform: scale(.6)
  opacity: .3
  transition-timing-function: cubic-bezier(.5,0,0,1)
  img
    width: 101%
    object-fit: cover
    height: 101%
    transition-duration: inherit
    transition-timing-function: inherit
    transform: scale(1.2)


.history__picture, .history__slide_content
  height: 70vh
  @media (max-width: $m-desktop)
    height: 60vh
  @media (max-width: $s-desktop)
    height: 45vh
  @media (max-width: $b-tablet)
    height: 30vh

.history__slide_content
  width: 40%
  display: flex
  flex-direction: column
  justify-content: space-between
  padding-right: 5vw
  @media (max-width: $s-desktop)
    width: 50%
  @media (max-width: $b-tablet)
    width: 100%
    padding-right: 0

.history__slide_title
  +yo('font-size', (1920px: 48px, 1024px: 40px))
  color: $grey6
  line-height: 1
  font-family: 'Baza'
  margin-bottom: 40px
  @media (max-width: $l-desktop)
    margin-bottom: 30px
  @media (max-width: $s-desktop)
    margin-bottom: 15px
  @media (max-width: $b-tablet)
    margin-top: 40px
    margin-bottom: 20px
  span
    transition-timing-function: ease
    transition-duration: .7s
    transform: translateY(40%)
    display: block
    opacity: 0
    &:nth-child(1)
      transition-delay: .2s
    &:nth-child(2)
      transition-delay: .3s

.history__slide_year
  font-family: 'Baza'
  color: $gold
  +yo('font-size', (1920px: 250px, 1024px: 136px))
  line-height: .8
  display: flex
  @media (max-width: $m-desktop)
    margin-bottom: 25px
  @media (max-width: $b-tablet)
    margin-bottom: -40px
    z-index: 2
    position: absolute
  span
    transition-timing-function: ease
    transition-duration: .7s
    opacity: 0
    display: block
    transform: translateY(20%)
    &:nth-child(1)
      transition-delay: .1s
    &:nth-child(2)
      transition-delay: .2s
    &:nth-child(3)
      transition-delay: .3s
    &:nth-child(4)
      transition-delay: .4s

.history__slide_description
  max-width: 400px
  color: rgba(255, 255, 255, .6)
  +yo('font-size', (1920px: 15px, 375px: 14px))
  font-family: 'Futura PT Book'
  display: grid
  grid-gap: 5px
  margin-bottom: 10px
  @media (max-width: $l-desktop)
    margin-bottom: 0
  @media (max-width: $b-tablet)
    max-width: 100%
    display: inline-block
  span
    transition-timing-function: ease
    transition-duration: .7s
    transform: translateY(10px)
    display: block
    opacity: 0
    transition-delay: .3s
    @media (max-width: $b-tablet)
      display: none
      line-height: 1.6
      &:nth-child(1), &:nth-child(2), &:nth-child(3), &:nth-child(4), &:nth-child(5)
        display: inline
.history__slide_controls
  display: flex
  grid-gap: 10px
  margin-left: -11px

.history__slide_control
  color: $gold3
  background: none
  text-transform: uppercase
  font-size: 11px
  border: none
  padding: 0
  font-family: 'Futura PT Book'
  letter-spacing: 3px
  transition-timing-function: ease
  transition-duration: .7s
  transform: translateY(10px)
  opacity: 0
  transition-delay: .4s

</style>
